<app-mi-page-nav />
<div class="container-fluid">
  @if (miReports.length > 1) {
    <div class="row mt-3">
      <div class="col">
        <div class="float-end mb-0">
          <select
            name="powerbi-reports"
            id="powerbi-reports"
            class="form-select"
            (change)="reportChange($any($event.target).value)"
          >
            @for (item of miReports; track item.id) {
              <option value="{{ item.id }}">
                {{ item.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
  }

  <div class="mt-3">
    @if (embedConfig) {
      <lib-powerbi
        type="report"
        [id]="embedConfig.id"
        [embedUrl]="embedConfig.embedUrl"
        [accessToken]="embedConfig.embedToken.token"
        [options]="{ filterPaneEnabled: false }"
      />
    }
  </div>
</div>
